const OPERATORS = {
    EQUALS_OPERATOR: 'equals',
    AND_OPERATOR: 'and',
    AND_NOT_OPERATOR: 'and not',
    OR_OPERATOR: 'or',
    CONTAINS_OPERATOR: 'contains',
    STARTS_WITH_OPERATOR: 'starts with',

    EXISTS_OPERATOR: 'exists',
    IS_OPERATOR: 'is',
    COLLECTIVE_OPERATOR: 'collective',
    GEODISTANCE_OPERATOR: 'geoDistance',
    GEOPOLYGON_OPERATOR: 'geoPolygon',
    NESTED_OPERATOR: 'nested',
    COMPARE_OPERATOR: 'compare',
    // Range Operator
    GREATER_THAN_OPERATOR: '>=',
    LESS_THAN_OPERATOR: '<=',
    DOUBLE_EQUALS_OPERATOR: '==',

    // Date Range Operator
    DATE_FROM_OPERATOR: 'from',
    DATE_TO_OPERATOR: 'to',
    DATE_ON_OPERATOR: 'on',

    // Results Format
    RESULTS_FORMAT: 'resultsFormat',
    RESULTS_FORMAT_SORT: 'resultsFormatSort',
};

const COMPARABLE_TYPE = {
    SALES: 'sales',
    LISTINGS: 'listings',
    RENTALS: 'rentals',
};

const PRICE_FIELD = {
    [COMPARABLE_TYPE.SALES]: 'salesLastSoldPrice',
    [COMPARABLE_TYPE.LISTINGS]: 'salesLastCampaignLastListedPriceDescription',
    [COMPARABLE_TYPE.RENTALS]: 'rentalLastCampaignLastListedPrice',
};

const DATE_FIELD = {
    [COMPARABLE_TYPE.SALES]: 'salesLastSaleContractDate',
    [COMPARABLE_TYPE.LISTINGS]: 'salesLastCampaignStartDate',
    [COMPARABLE_TYPE.RENTALS]: 'rentalLastCampaignStartDate',
};

const DOM_FIELD = {
    [COMPARABLE_TYPE.SALES]: 'salesLastCampaignDaysOnMarket',
    [COMPARABLE_TYPE.LISTINGS]: 'salesLastCampaignDaysOnMarket',
    [COMPARABLE_TYPE.RENTALS]: 'rentalLastCampaignDaysOnMarket',
};

const DEFAULT_RESULTS_FORMAT = {
    offset: 0,
    limit: 20,
    metadata: false,
};

const rapidSearch = {
    OPERATORS,
    DEFAULT_RESULTS_FORMAT,
    PRICE_FIELD,
    DATE_FIELD,
    DOM_FIELD,
    COMPARABLE_TYPE,
};

export default rapidSearch;
